const LayoutAdmin = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default LayoutAdmin;
